/**
 * Hide prices for "All Bikes" products (high-value items) in Rapid Search results
 * Uses price value detection for immediate hiding
 */

// Function to extract numeric price from text
function getPriceValue(text) {
  if (!text) return 0;
  // Remove currency symbols and commas, extract number
  const match = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
  return parseFloat(match) || 0;
}

// Function to hide price elements
function hidePrice(element) {
  if (element) {
    element.style.display = 'none';
    element.style.visibility = 'hidden';
  }
}

// Function to process search results and hide bike prices
function hideBikePrices() {
  // Target all Rapid Search price elements
  const priceElements = document.querySelectorAll(`
    [class*="rps"] [class*="price"],
    [class*="rapid-search"] [class*="price"],
    .predictive-search__item .price,
    [class*="search-result"] [class*="price"]
  `);

  priceElements.forEach(priceElement => {
    const priceText = priceElement.textContent || priceElement.innerText;
    const priceValue = getPriceValue(priceText);

    // If price is $5000 or more, it's likely a bike - hide it
    if (priceValue >= 5000) {
      hidePrice(priceElement);

      // Also hide parent price containers
      let parent = priceElement.parentElement;
      while (parent && parent !== document.body) {
        const className = parent.className || '';
        if (className.includes('price') || className.includes('cost') || className.includes('amount')) {
          hidePrice(parent);
          break;
        }
        parent = parent.parentElement;
      }
    }
  });
}

// Run immediately
hideBikePrices();

// Set up MutationObserver to watch for search results
const observer = new MutationObserver((mutations) => {
  let shouldProcess = false;

  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          const className = node.className || '';
          const hasSearchContent =
            className.includes('rps') ||
            className.includes('search') ||
            className.includes('result') ||
            node.querySelector('[class*="rps"]') ||
            node.querySelector('[class*="price"]');

          if (hasSearchContent) {
            shouldProcess = true;
            break;
          }
        }
      }
    }
  }

  if (shouldProcess) {
    // Run after a short delay to ensure content is rendered
    setTimeout(hideBikePrices, 100);
    setTimeout(hideBikePrices, 300);
    setTimeout(hideBikePrices, 500);
  }
});

// Observe the entire document
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also run when search input changes
document.addEventListener('input', (e) => {
  const target = e.target;
  const isSearchInput =
    target.type === 'search' ||
    target.className.includes('search') ||
    target.id.includes('search');

  if (isSearchInput) {
    setTimeout(hideBikePrices, 200);
    setTimeout(hideBikePrices, 500);
    setTimeout(hideBikePrices, 1000);
  }
});

// Run periodically for first 5 seconds to catch any delayed renders
let runCount = 0;
const periodicCheck = setInterval(() => {
  hideBikePrices();
  runCount++;
  if (runCount >= 10) {
    clearInterval(periodicCheck);
  }
}, 500);

// Run on scroll (in case search results lazy load)
let scrollTimeout;
document.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(hideBikePrices, 100);
}, { passive: true });

console.log('Bike price hiding script loaded');
